import React, { useState, useImperativeHandle } from 'react';
import { Modal, Select, Form } from 'antd';
import { CheckboxWithAll } from '../../components';
const { Option } = Select;
const SetRoleBybatch = (props) => {
 const { visible, targetList, onOk, onCancel, roleList = [] } = props;
 const [form] = Form.useForm();
 const handleBatchRole = () => {
  form.validateFields().then(
   (values) => {
    onOk && onOk(values);
   }
  );
 };

 return (
  <Modal
   visible={visible}
   title='批量选择角色'
   onOk={handleBatchRole}
   onCancel={() => { onCancel && onCancel(); } }
  >
   <Form name="setRole" layout='vertical' form={form}>
    <Form.Item  name='roleMembers' rules={[{ required: true, message: '请选择成员' }]}>
     <CheckboxWithAll options={targetList}/>
    </Form.Item>
    <Form.Item name='roleId' rules={[{ required: true, message: '请选择角色' }]} label='选择角色'>
     <Select style={{ width: '100%' }} placeholder='请选择' >
      {
       roleList.map((item, index) => {
        return <Option key={index + 'role'} value={item.id}>{item.name}</Option>;
       })
      }
     </Select>
    </Form.Item>
   </Form>
  </Modal>);
};

export default SetRoleBybatch;